import { Link } from "react-router";
import { SmartImage } from "~/components/utils/SmartImage";


export default function AboutSection() {
    return (
        <section id="about" className="about">
            <div className="container">
                <div className="row">
                    <div className="col-12" data-aos-delay="100">
                        <h2 className="homeAbout">Training That Works When It Matters</h2>
                    </div>
                    <div className="col-lg-5 order-1 order-lg-2" data-aos-delay="100">
                        <SmartImage
                            src="/img/home-about.jpeg"
                            alt="About us"
                            className="img-fluid"
                            widths={[640]}
                            fit="cover"
                            />
                    </div>
                    <div className="col-lg-7 pt-4 pt-lg-0 order-2 order-lg-1 content">
                        <p className="fst-italic homeAboutSub">
                            We deliver first aid training awarded by FAIB and mental health first aid courses through NUCO — nationally recognised qualifications that meet HSE and employer requirements.
                        </p>
                        <p>Every course is built around your actual workplace. We adapt scenarios, examples, and practical exercises to match your environment and risks, whether that's an office, a warehouse, a school, or a construction site. Your staff leave knowing what to do, not just what to recite.</p>
                        <p>We work with employers who want:</p>
                        <p><strong>First Aid Training (FAIB)</strong> From Emergency First Aid at Work through to the full 3-day qualification. Realistic scenarios, clear decision-making, and skills that stick.</p>
                        <p><strong>First Aid for Mental Health (NUCO)</strong> From awareness sessions to the full 2-day Mental Health First Aider course. Recognising early signs, responding safely, and knowing when to escalate.</p>
                        <p><strong>Health & Safety</strong> Fire Marshal, Moving & Handling, COSHH, and related workplace safety courses focused on prevention and responsibility.</p>

                        <p className="homeAboutContact">
                            <Link className="btn-get-started" to='/courses'>View All Courses</Link> — <Link className="btn-get-started" to='/training-discussion'>Request a Training Discussion</Link>.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}